<ion-badge
  [color]="params.color"
  class="status-badge"
  role="status"
  aria-live="polite">
  {{ params.label }}
</ion-badge>
